import { render, staticRenderFns } from "./IconCircleArrowRight.vue?vue&type=template&id=d5fb3b9a&"
import script from "./IconCircleArrowRight.vue?vue&type=script&lang=js&"
export * from "./IconCircleArrowRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports